export default __webpack_public_path__ + "static/media/video-white.6358b523.svg";